// Copy-to-clipboard chip. Used by ErrorBanner for X-Request-Id and
// by detail pages for UUIDs / paths.

import { useState } from "react";

interface CopyButtonProps {
  value: string;
  label?: string;
  title?: string;
}

export function CopyButton({ value, label = "Copy", title }: CopyButtonProps) {
  const [copied, setCopied] = useState(false);
  const onClick = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    } catch {
      // Older browsers / insecure context: silently ignore. Operator
      // can still select the text manually.
    }
  };
  return (
    <button
      type="button"
      onClick={onClick}
      title={title ?? `Copy: ${value}`}
      style={{
        background: "transparent",
        color: copied ? "var(--ok)" : "var(--text-dim)",
        border: "1px solid var(--border)",
        padding: "2px 8px",
        borderRadius: 4,
        fontSize: "0.72rem",
        cursor: "pointer",
        fontFamily: "inherit",
      }}
    >
      {copied ? "Copied" : label}
    </button>
  );
}
